import React from "react";
import { Button, Drawer, Form, Input, message } from "antd";
import { PaymentTermGet, PaymentTermUpdate, PaymentTermPost } from "../../../../../models/paymentTerm";

const FormItem = Form.Item;

class EditPaymentMethodDataForm extends React.Component {
    state = {};

    componentDidMount() {
        if (this.props.onRef)
            this.props.onRef(this)
    }

    componentDidUpdate(prevProps) {
        const { visible, row_id } = this.props;
        if (visible && row_id && (visible !== prevProps.visible && row_id !== prevProps.row_id))
            this.fetchPaymentTerm(row_id);
    }

    componentWillUnmount() {
        if (this.props.onRef)
            this.props.onRef(null)
    }

    fetchPaymentTerm = (id) => {
        let form = this.props.form;
        PaymentTermGet(id)
            .then(response => {
                form.setFieldsValue(
                    {
                        name: response.data.name
                    },
                )
            }
            );
    }
    handleDrawerSubmit = (e) => {
        this.props.form.validateFields((err, values) => {
            if (!this.props.row_id) {
                PaymentTermPost(values)
                    .then(response => {
                        message.success('Payment Method Create Successfully');
                        this.handlePopupAfterAddUpdate();
                    })
            }
            else {
                PaymentTermUpdate(this.props.row_id, values)
                    .then(response => {
                        message.success('Payment Method Updated Successfully');
                        this.handlePopupAfterAddUpdate();
                    });

            }
        });
    };
    handlePopupAfterAddUpdate = () => {
        this.props.onClose()
        this.props.fetch();
    };
    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <Drawer title={this.props.row_id ? "Update Payment Method" : "Create Payment Method"} placement="right" row_id={this.props.row_id} onClose={this.props.onClose} visible={this.props.visible} className="floating-form" destroyOnClose={true}>
                <Form>
                    <FormItem>
                        {getFieldDecorator('name', {
                            rules: [{
                                required: true, message: 'Please input payment method',
                            }],
                        })(
                            <Input placeholder="Enter Payment Method" />
                        )}
                    </FormItem>
                    <Button type="primary" htmlType="button" onClick={this.handleDrawerSubmit}>{this.props.row_id ? "Update Payment Method" : "Create Payment Method"}</Button>
                </Form>
            </Drawer>
        )
    }
}

export const EditPaymentMethodData = Form.create()(EditPaymentMethodDataForm);



// WEBPACK FOOTER //
// ./src/pages/tracks/data_management/payment_method/popups/EditPaymentMethodData.jsx